<template>
  <div class="w-100">
    <!-- Contenido de la tabla -->
    <table
      class="table table-bordered stripe display compact hover"
      :id="nombreTabla"
    >
      <!-- Headers -->
      <thead>
        <tr>
          <!-- Tabla con headers personalizados -->
          <template>
            <th style="font-size: 13px !important; min-width: 282px">
              Nombre puerto
            </th>
            <th style="font-size: 13px !important; min-width: 150px">
              TT Reefer
            </th>
            <th style="font-size: 13px !important; min-width: 150px">TT Dry</th>
            <th style="font-size: 13px !important; min-width: 150px"> Corte Documental Anticipado</th>
            <th style="font-size: 13px !important; min-width: 80px">
              Acciones
            </th>
          </template>
        </tr>
      </thead>

      <!-- Body -->
      <tbody>
        <!-- Recorre el total de objectos dentro del array -->
        <tr v-for="(item, index) in dataAux" :key="index"  >
          <!-- Si se encuentra la opción (Props) numerador se mostrará esta sección en la tabla, la cual habilita la numeración de numeros correlativos iniciando desde el n° 1 -->
          <!-- SI ESTÁ HABILITADO EL MODO FORMULARIO, SE MUESTRA ESTA SECCIÓN  -->
          <template>
            <td
              v-for="(item_data, index_data) in item.data"
              :key="index_data"
              style="font-size: 12.5px !important"
            >
              <!-- Muestra en la tabla los valores dentro del input / checkbox o select correspondiente -->
              <template v-for="(type, index_type) in item.type">
                <template v-if="type.key == index_data">
                  <!-- Textbox -->
                  <input
                    v-if="type.type == 'textbox'"
                    class="textbox_normal w-100"
                    style="padding: 7px 5px; !important"
                    :key="index_type"
                    v-model="item.data[index_data]"
                  />

                  <input
                    v-if="type.type == 'checkbox'"
                    class="form-check-input ml-5 mt-2 position-relative"
                    type="checkbox"
                    style="padding: 7px 5px; !important"
                    :key="index_type"
                    v-model="item.data[index_data]"
                  />

                  <!-- Texto plano -->
                  <template v-if="type.type == 'text'">
                    <div :key="index_type.type">
                      {{
                        item.data[index_data] == "-"
                          ? "Sin asignar"
                          : item.data[index_data].name
                      }}
                    </div>
                  </template>
                </template>
              </template>
            </td>
          </template>

          <!-- 
            Acciones 
        -->
          <td v-if="acciones.length > 0">
            <a
              v-for="(item_acciones, index_2) in acciones[index]"
              :key="index_2"
              class="btn btn-sm icono"
              style="text-align: center; width: 100%"
              @click="filaSeleccionada(item_acciones.id, item_acciones.title)"
            >
              <i
                :class="item_acciones.icon"
                :title="item_acciones.title"
                style="text-align: center"
                :style="[
                  {
                    'font-size': item_acciones.size
                      ? item_acciones.size + 'px'
                      : '11.7px',
                  },
                ]"
              ></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <button @click="guardarTransbordos();" id="buttonRef3" class="btn btn-outline-warning btn-sm float-left mt-2"> 
      Actualizar
    </button>
  </div>
</template>

<script>

import Vue from "vue";
import { mapActions } from "vuex";
import VueToastify from "vue-toastify";
Vue.use(VueToastify);
// Importación de Jquery
import $ from "jquery";
import { editarAgregarEliminarPuertoTransbordo } from "../../../constants/lineas";

export default {
  props: {
    data: Array, // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    idtabla: {
      type: String,
      default: "id_generico",
    },
    funcionAuxiliar: { type: Function, default: () => ({}) },
    seleccionar: { type: Function, default: () => ({}) },
    id_tab: { type: Number },
    transbordosParaBorrar : Array,
    cambiarTabSeleccionada: { type: Function, default: () => ({}) },
    nombreServicio: {type: String, default:""},
    idServicio: { type: Number }
  },

  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Ultimo",
          next: "Siguiente",
          previous: "Anterior",
        },
        // buttons: {
        //   colvis: "Seleccionar columnas",
        // },
      },
      nombreTabla: "id_tabla_" + this.idtabla,
      dataAux: this.data,
      accionesAux: this.acciones,
      flagFormulario: false,
      options: [],
      selected: [],
      selectAll: false,
      idSelectedServicio: this.idServicio
    };
  },

  methods: {
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),

    filaSeleccionada(id, accion) {
      this.seleccionar({ id, accion, id_tab: this.id_tab });
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef3");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async guardarTransbordos(){

      let valid = true ;

      console.log(this.dataAux);

      this.dataAux.forEach( dt => {
        if( dt.data[1] < 1 ) valid = false ;
        if( dt.data[2] < 1 ) valid = false ;
      });

       if( !valid ) return this.$vToastify.error(
        "No deben quedar campos en 0 o menor a 0",
        "Error"
      );

      const form = {
        transbordosParaBorrar : [],
        data : this.ordenarData(),
        nombreServicio: this.nombreServicio,
        idServicio: this.idSelectedServicio,
      };
      
      try {
        this.$vToastify.loader("Actualizando Servicio...");
        this.estadoButton("Actualizando...");
        const { message, status } = await editarAgregarEliminarPuertoTransbordo(form) ;
        this.estadoButton("Actualizar", false);
        this.$vToastify.stopLoader();
        
        if( status ){
          await this.cambiarTabSeleccionada( this.id_tab );
          this.$vToastify.success(
            "Transbordos editados con éxito",
            "¡Realizado!"
          );

        } else {
          this.$vToastify.error(
            message,
            "Lo sentimos"
          );
        }  
      } catch (error) {

        this.$vToastify.error(
            "Error al editar datos, por favor intente más tarde.",
            "Lo sentimos"
          );
      }
      
    },
    ordenarData(){
      return this.dataAux.map( d => ({
        accion : d.accion,
        //Cuando se crea o actualiza se ocupa el mismo campo id
        id: parseInt(d.data[0].id),
        tt_dry: parseInt(d.data[2]),
        tt_reefer: parseInt( d.data[1] ),
        has_early_cutoff:  d.data[3] ,
        transfer_id : d.transfer_id,
        name_port : d.data[0].name
      }));
    },
    configuracionDatatable() {
      let me = this;
      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          // buttons: [
          //   "colvis",
          //   {
          //     text: "Hooola",
          //     extend: "excel",
          //     title: "Diego",
          //     exportOptions: {
          //       columns: [0, 1, 2, 3, 4, 5],
          //     },
          //   },
          // ],
          language: me.lang,
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");

      $(".exportar-tabla").click(() => {
        $("#" + me.nombreTabla)
          .DataTable()
          .buttons(2 - 1)
          .trigger();
      });
    },
  },

  mounted() {
   // let me = this;
   // me.configuracionDatatable();
  },

  watch: {
    data: function ( _new ) {

      if (_new) {

        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();

        this.dataAux = _new;


      }
    },

    acciones: function (_new) {
      if (_new) {
        this.accionesAux = _new;
      }
    },
  },
};
</script>

<style>
.hide-button-excel {
  display: none;
}

.buttons-colvis {
  background-color: #dc3545;
  color: #ffff;
  padding: 6px;
  border: none;
  border-radius: 3px;
  font-size: 15px;
}

.buttons-colvis:hover {
  background-color: #bd2130;
  border: none;
}

div.dataTables_wrapper div.dataTables_info {
  font-size: 13px !important;
}

.icono {
  opacity: 0.7;
}

.icono:hover {
  opacity: 1;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 0.25rem 0.45rem !important;
}

/* Table compact */

table.dataTable.compact thead th,
table.dataTable.compact thead td {
  padding: 3px 5px;
}
table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
  padding: 3px;
}
table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
  padding: 3px;
}

/* Table Hover */

table.dataTable.hover > tbody > tr:hover > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
}

/* Stripe (Pintado de tabla estilo cebra) */

table.dataTable.stripe > tbody > tr.odd > *,
table.dataTable.display > tbody > tr.odd > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
}

/*  */

table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting_asc_disabled,
table.dataTable thead > tr > th.sorting_desc_disabled,
table.dataTable thead > tr > td.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting_asc_disabled,
table.dataTable thead > tr > td.sorting_desc_disabled {
  cursor: pointer;
  position: relative;
  padding: 10px 0 !important;
  text-align: center;
}
</style>
